import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DestroyBase } from "../../../../components/common/ng-destroy-base";
import { RaciService } from "../../../raci/services/raci.service";
import { ValuationEventParticipantsService } from "../../services/valuation-event-participants.service";
import { AppStorageService } from "../../../../services/app-storage.service";

/**
 * Handles the valuation event participants component
 */
@Component({
  selector: 'valuation-event-participants',
  templateUrl: './valuation-event-participants.component.html',
  styleUrls: ['./valuation-event-participants.component.css']
})
export class ValuationEventParticipantsComponent extends DestroyBase implements OnInit {
  /**
   * valuationPortfolio data
   */
  @Input()
  get data(): any { return this._data; }
  set data(value: any) {
    this._data = value;
    if (value) {
      this.valuationPortfolioId = value.Oid;
      this.projectId = value.ProjectID;
      setTimeout(this.loadProperties.bind(this));
    } else {
      this.displaySelected();
    }
  }

  /**
   * Can be closed? (as Infobar in table view)
   */
  @Input() canClose: boolean;

  /**
   * Close pane event
   */
  @Output() closePane: EventEmitter<any> = new EventEmitter();

  /**
   * ValuationPortfolio data
   */
  private _data: number;

  /**
   * List of participants
   */
  participants: any;

  /**
   * ValuationPortfolio Id
   */
  valuationPortfolioId: number;

  /**
  * Project Id
  */
  projectId: number;

  /**
   * Should the pane be closed?
   */
  shouldClose = false;

  /**
   * Should save the participants
   * */
  shouldSave = false;

  /**
   * Number of steps (no steps, so 0).. here just for close button
   */
  stepsCount = 0;

  /**
   * Current step
   */
  currentStep = 1;

  /**
   * Select all participants
   */
  selectAllParticipants = false;

  /**
   * Close was clicked
   */
  onCloseClicked() {
    this.shouldClose = true;
    setTimeout(() => {
      if (this.shouldSave)
        this.saveParticipants();
      this.closePane.emit();
    }, 500);
  }

  /**
   * Constructor
   * @param raciService
   * @param valuationEventParticipantsService
   */
  constructor(private appStorage: AppStorageService,
    /**
 * RACI service for managing RACI templates
 */
    private raciService: RaciService,
    /**
 * Valuation Event Participants service for managing participants in a valuation event
 */
    private valuationEventParticipantsService: ValuationEventParticipantsService) {
    super();
  }

  /**
  * Initializes the component
  */
  ngOnInit(): void {
    if (!this.data) {
      this.displaySelected();
    }
  }

  /**
   * Loads properties and participants for the valuation event
   */
  loadProperties(): void {
    this.raciService.getParticipants(true, this.valuationPortfolioId, this.projectId)
      .subscribe(data => {
        if (data) {
          this.participants = data;
          if (!this.participants.find(participant => !participant.isLinkedToPortfolio)) {
            this.selectAllParticipants = true;
          }
        }
      });
  }

  /**
   * Displays the selected portfolio
   */
  displaySelected() {
    const item = this.appStorage.getSelectedPortfolio();
    if (item) {
      this.data = item;
    }
  }

  /**
   * Saves the selected participants' assignments
   */
  saveParticipants() {
    const selectedParticipants = this.participants
      .filter(participant => participant.isLinkedToPortfolio)
      .map(participant => this.createNewAssignment(participant));

    this.valuationEventParticipantsService.saveParticipantsAssignments(this.valuationPortfolioId, selectedParticipants)
      .subscribe();
  }

  /**
   * Changes the save status and the linked status of a participant
   * @param participant The participant to modify
   */
  changeSaveStatus(participant: any) {
    this.shouldSave = true;
    participant.isLinkedToPortfolio = !participant.isLinkedToPortfolio;
    if (!this.participants.find(participant => !participant.isLinkedToPortfolio)) {
      this.selectAllParticipants = true;
    } else {
      this.selectAllParticipants = false;
    }
  }

  /**
   * Selects or deselects all participants
   */
  selectAll() {
    this.shouldSave = true;
    this.selectAllParticipants = !this.selectAllParticipants;
    this.participants.forEach(participant => participant.isLinkedToPortfolio = this.selectAllParticipants);
  }

  /**
   * Creates a new assignment object based on a participant
   * @param participant The participant to create an assignment for
   * @returns The created assignment object
   */
  createNewAssignment(participant: any) {
    return {
      "roleId": participant.projectRoleId,
      "roleDescription": participant.projectRole,
      "userId": participant.userId,
      "valuationProjectId": this.valuationPortfolioId,
      "mail": participant.email,
      "external": participant.isExternal
    };
  }
}
